import React from "react";
import { SectionDivider, SectionWrapper, Title } from "./Styled";
import { LeftNavTab, LeftNavTabContent } from "../../../configs/leftNavTabs";
import Content from "./Content";

const Section = ({ title, tabList, isCollapsed }: LeftNavTab) => {

    return (
        <SectionWrapper>
            <Title isCollasped={isCollapsed}>
                {!isCollapsed ? title : <SectionDivider />}
            </Title>

            {tabList.map((tab: LeftNavTabContent) => (
                <Content
                    key={tab.key}
                    tabIcon={tab.tabIcon}
                    label={tab.label}
                    route={tab.route}
                    routeGroup={tab.routeGroup}
                    isCollapsed={isCollapsed}
                />
            ))}
        </SectionWrapper>
    );
};

export default Section;
